import DefaultUpdateProgressDetails from "src/components/feature/UpdateProgressDetails";

const UpdateProgressDetails = () => {
  return <DefaultUpdateProgressDetails />;
};

export default UpdateProgressDetails;
